<template>
  <div class="row">
    <div class="col-12">
      <div class="card d-none">
        <div class="card-body bg-light">
          <div class="row">
            <div class="col-md-2 col-lg-5">
              <h3 class="mb-2 text-dark">
                Itens
              </h3>
            </div>
            <div class="col-md-10 col-lg-7 text-right">
              <div class="row">
                <!-- <div class="col-md-6">
                  <span
                    v-if="!executaveis"
                    class="btn font-weight-light bg-yellow d-block d-md-inline-block"
                    ><i class="fas fa-check-square"></i> Nenhum serviço</span
                  >&nbsp;
                  <span
                    v-if="executaveis"
                    class="btn btn-block"
                    :class="
                      executaveis.concluidos < executaveis.total
                        ? 'bg-yellow'
                        : 'bg-success text-white'
                    "
                  >
                    <i
                      class="far fa-check-square"
                      v-if="executaveis.concluidos < executaveis.total"
                    ></i>
                    <i
                      class="fas fa-check-square"
                      v-if="executaveis.concluidos === executaveis.total"
                    ></i>

                    {{ executaveis.concluidos }} /
                    {{ executaveis.total }} Serviços concluídos </span
                  >&nbsp;
                </div> -->
                <div class="col-md-6">
                  <b-button
                    v-if="!veiculoLiberado"
                    class="btn btn-success btn-block"
                    :disabled="disableLiberar || saving"
                    @click="liberarVeiculo"
                  >
                    <span v-if="!saving">
                      <i class="fa fa-thumbs-up"></i> Liberar veículo
                    </span>
                    <span v-if="saving">
                      <i class="fa fa-pulse fa-spinner"></i> Liberando...
                    </span>
                  </b-button>
                  <span
                    class="text-muted text-sm"
                    v-if="disableLiberar"
                    >Conclua todos os serviços para habilitar</span
                  >
                  <span
                    class="text-muted text-sm"
                    v-if="disableLiberar"
                    >Adicione e conclua ao menos um serviço para habilitar</span
                  >

                  <span class="btn bg-success btn-block disabled" v-if="veiculoLiberado">
                    <i class="fa fa-check"></i> Veiculo liberado
                  </span>
                </div>
              </div>

              <div></div>
            </div>
          </div>
          <div class="float-right"></div>
        </div>
      </div>
    </div>
    <div class="col-12">

      <os-item-preventiva 
          v-if="this.os.nr_seq_tipo == 'V' || this.os.nr_seq_tipo == 'R'"
          :os="os"
          >
        </os-item-preventiva>
        
      <div v-if="items == 'loading'" class="w-100 text-center">
        {{this.$t('Carregando')}}...
      </div>
      <div v-if="items !== 'loading'">
        <!-- <os-item-form
          :disabled="veiculoLiberado"
          :os-id="$route.params.id"
          :os-items="items"
          @iniciar-atendimento="iniciarAtendimento"
        ></os-item-form> -->

        <div v-if="this.os.nr_seq_tipo != 'V' && this.os.nr_seq_tipo != 'R'">
          <os-item
            :disabled="veiculoLiberado"
            :os="os"
            v-for="(item, index) in items"
            :key="index"
            :item="item"
            :initAt=initAtendimento
          ></os-item>
          <os-comentarios
           :os="os"
           >
          </os-comentarios>
        </div>
        <div style="display: flex; justify-content: end" v-if="osExternaPreventiva && showFornecExt">
          <button class="btn w-50 btn-secondary btn-block mb-2" @click="showModalFornec = true">
            <i class="fas fa-users"></i> {{ this.$t('Alterar Fornecedor') }}
          </button>
        </div>
      </div>
    </div>
    <modal-tecnicos></modal-tecnicos>
    <modal-fornecedores @saveFornec="fornecOs" :os="os" @showModalFornec="showModalFornec = false"
      v-if="showModalFornec"></modal-fornecedores>
  </div>
</template>

<script>
import OsItem from '@/components/OsItem'
import OsComentarios from '@/components/OsComentarios'
// import OsItemForm from '@/components/OsItemForm'
import ModalFornecedores from './Modais/ModalFornecedores.vue';
import ModalTecnicos from '@/components/ModalTecnicos'
import OsItemPreventiva from './Preventivas/OsItemPreventiva.vue';


export default {
  components: {
    OsItem,
    // OsItemForm,
    ModalFornecedores,
    ModalTecnicos,
    OsItemPreventiva,
    OsComentarios

  },

  data () {
    return {
      currentModalAction: null,
      saving: false,
      initAtendimento: false,
      arrayValidatePecas: [],
      coutItensExec: 0,
      showModalFornec: false,
      showFornecExt: true
    }
  },
  computed: {
    items () {
      if(this.os.nr_seq_tipo == 'V' || this.os.nr_seq_tipo == 'R'){
        return this.$store.getters['osItem/itemsPreventiva']
      } else {
        return this.$store.getters['osItem/items']
      }
    },
    
    // executaveis () {
    //   if (!this.items) {
    //     return null
    //   }

    //   if (this.items === 'loading') {
    //     return null
    //   }

    //   var countExecutaveis = 0
    //   var countExecutaveisEncerrados = 0
    //   this.items.forEach(item => {
    //     if (item.item.tipo && item.item.tipo.st_habilita_execucao) {
    //       countExecutaveis++

    //       if (item.execucao_final && item.execucao_final.dt_final) {
    //         countExecutaveisEncerrados++
    //       }
    //     }
    //   })

    //   if (countExecutaveis === 0) {
    //     return null
    //   }

    //   return {
    //     total: countExecutaveis,
    //     concluidos: countExecutaveisEncerrados
    //   }
    // },
    disableLiberar () {
      if (!this.executaveis) return true

      if (this.executaveis.total === 0) return true

      return !(this.executaveis.concluidos === this.executaveis.total)
    },
    finalizarOsPreventiva(){
      if(this.os.nr_seq_tipo === "V") {
        return true
      } else {
        return false
      }
    },
    osExternaPreventiva () {
      if(this.os.st_origem == "E") {
        return true
      } else {
        return false
      }
    },
    os () {
      const os = this.$store.getters['os/details']
      console.log(os)
      if (!os) {
        return {}
      }

      return os
    },
    veiculoLiberado () {
      if (!this.os) {
        return null
      }

      if (this.os.dt_liberado) return true

      return false
    },
  },

  methods: {
    refreshPage() {
      location.reload()
    },
    fornecOs(codOs, codFornec) {
      const data = {
        nr_os: this.$route.params.id,
        nr_fornec: codFornec
      }

      this.$store.dispatch('os/enviaOsExterna', { data: data }).then(response => {
        this.showModalFornec = false

        this.$swal.fire({
          title: "Sucesso",
          text: "Ordem de serviço, vinculada com Sucesso!",
          icon: "success"
        })
        this.refreshPage()
      }).catch(error => {
        console.log(error)
      })
    },
    validateAllItems() {
      this.$store.dispatch('osItem/getItensExec', { nr_os: this.$route.params.id }).then(response => {
        if(response == this.items.length){
          this.$store.dispatch('osItemExecucao/finalizaItem', { codOs: this.$route.params.id }).then(response => {
            const encerraOs = response.data.finalizaItem[0].terminal_oficina_encerra_os
            if (encerraOs == 'A') {
              // Ainda está Aberta
            } else if (encerraOs == 'E') {
              // Já está fechada e direcionar para a home 
                window.location.href = `/`
            }
          })
        } else {
          this.$swal.fire({
            title: 'Oops!',
            text: 'Existem itens a serem executados, tente novamente!',
            icon: 'error'
          })
        }
      }) 
      .catch(error => {
        console.log(error)
      })
    },
    iniciarAtendimento(){
      this.initAtendimento = true
    },
    liberarVeiculo () {
      this.$root.confirmIdentity({
        onConfirmIdentity: (tecnicoId) => {
          var data = {
            nr_seq_clifor: tecnicoId
          }

          this.saving = true
          this.$store
            .dispatch('os/liberarVeiculo', {
              id: this.$route.params.id,
              data: data
            })
            .then(response => {
              this.$swal.fire({
                text: 'Veículo liberado',
                icon: 'success'
              })

              this.reload()
              return true
            })
            .catch(error => {
              console.error(error)
              this.$swal.fire({
                title: 'Oops!',
                text: 'Falha ao liberar o veículo. Tente novamente.',
                icon: 'error'
              })
            })
            .finally(() => {
              this.saving = false
            })
        }
      })
    },
    reload () {
      return this.$store.dispatch('os/getDetails', {
        nrSequencial: this.$route.params.id
      })
    }
  },

  created(){
    const filial = this.$store.getters['filial/filial']

    if(filial.fornecExt == "S"){
      this.showFornecExt = false
    }

  }
}
</script>
